import { render, staticRenderFns } from "./MassiveImportInfoSupervisorsCollaboratorsModal.vue?vue&type=template&id=f61591c0&scoped=true&"
import script from "./MassiveImportInfoSupervisorsCollaboratorsModal.vue?vue&type=script&lang=js&"
export * from "./MassiveImportInfoSupervisorsCollaboratorsModal.vue?vue&type=script&lang=js&"
import style0 from "./MassiveImportInfoSupervisorsCollaboratorsModal.vue?vue&type=style&index=0&id=f61591c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61591c0",
  null
  
)

export default component.exports